export const PolicyFooter = ({ className = "" }) => (
  <div className={`text-center text-xs text-brand-ink/40 ${className}`} data-testid="policy-footer">
    <a href="/privacy" className="hover:text-brand-green transition-colors">Privacy Policy</a>
    <span className="mx-2 text-brand-ink/25">|</span>
    <a href="/terms" className="hover:text-brand-green transition-colors">Terms</a>
    <span className="mx-2 text-brand-ink/25">|</span>
    <a href="/refund" className="hover:text-brand-green transition-colors">Refund Policy</a>
  </div>
);
